import React from "react";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import { useAuth } from "../../hooks/useAuth";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import {
  Container,
  ContentText,
  LinkDoc,
  Text,
  ViewImages,
  Images,
  DivForm,
  Img,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";

import regulamentojornada from "../../assets/docs/jornadaregulamento.pdf";


const openForm = () => {
  window.open("https://docs.google.com/forms/d/e/1FAIpQLSe0iCA0E5sDf78JdJZ-wVjeLpOCX51w7Dk1rkRziAvHSz60Pw/viewform");
};


const ProjectMath = () => {

  const { user } = useAuth();

  const imagesGalery = [
    {
      original: images.math1,
      thumbnail: images.math1,
    },
    {
      original: images.math2,
      thumbnail: images.math2,
    },
    {
      original: images.math3,
      thumbnail: images.math3,
    },
    {
      original: images.math4,
      thumbnail: images.math4,
    },
    {
      original: images.math5,
      thumbnail: images.math5,
    },
    {
      original: images.math6,
      thumbnail: images.math6,
    },
    {
      original: images.math7,
      thumbnail: images.math7,
    },    
    {
      original: images.math8,
      thumbnail: images.math8,
    },   

  ];

  return (
    <Container>
      <Menu />
      <Banner icon={images.icon_jornada}>JORNADA MATEMÁTICA</Banner>
      <ContentBox>
        
          <ViewImages>
            <Images>
              <ImageGallery 
              items={imagesGalery} 
              showBullets={true} 
              autoPlay={true} 
              showNav={false} 
              thumbnailPosition={"right"} 
              />
            </Images>
          </ViewImages>

          <ContentText>
          <Text> A Jornada Matemática é uma proposta que desafia os(as) estudantes do 5º ano das escolas
            municipais a colocarem em prática tudo o que aprenderam em Matemática. Por meio de atividades
            que envolvem cálculos e resolução de problemas, o projeto estimula o desenvolvimento de habilidades 
            essenciais para a vida escolar. 
          </Text>

          <Text>Com o propósito de criar, na sala de aula, um contexto favorável à aprendizagem das diversas
            modalidades e pautado na resolução de problemas, a jornada busca envolver os(as) estudantes em 
            atividades voltadas ao desenvolvimento de diferentes estratégias, adequadas aos anos/séries avaliadas.
          </Text>

          <Text> Alinhado ao Objetivo de Desenvolvimento Sustentável 5 da ONU, que visa alcançar a igualdade de gênero,
            o regulamento da Jornada Matemática orienta a formação das equipes, reafirmando o compromisso da rede municipal 
            de ensino de Mogi das Cruzes com a construção de um futuro onde a Matemática seja acessível e 
            representativa para todos.
          </Text>

          <LinkDoc href={regulamentojornada} target="_blank">* Regulamento (Clique aqui)</LinkDoc>
          {/* <LinkDoc href={resolucaoaprende} target="_blank">* Resolução Aprende Mais Mogi (Clique aqui)</LinkDoc> */}
          {user &&
        (user.profiles[0].idProfile === '672c9f68-bcb7-4657-98c6-beb828c0729a' ||
        user.profiles[0].idProfile === 'ef49171e-13f3-4a88-a177-4a52a58e7bd1' ||
        user.profiles[0].idProfile === 'b56d58fe-2377-4428-854d-5f20670fb166' ||
        user.profiles[0].idProfile === '8bcc6f27-d0eb-413b-8e11-c34abb07689c' ) && 
          ( <DivForm>
                <Img src={images.note}></Img>
                <Text>Formulário de inscrição:</Text>

                <LinkDoc onClick={openForm}>Clique aqui para preencher</LinkDoc>
            </DivForm>
          )}         

        </ContentText>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ProjectMath;